import React, { useCallback, useEffect, useState } from 'react';
import Button from '../../ui/Button';
import Spinner from '../../ui/Spinner';
import { documentDesignService } from '../../../services/documentDesignService';
import { mediaAssetPreviewUrl } from './mediaCreatorAssetPreview';
import { isTransparentAsset } from './mediaCreatorHtmlResolve';

const MediaAssetPickModal = ({
  title,
  onClose,
  onPick,
  initialQuery = '',
  searchPlaceholder,
  role = 'photo',
  preset = 'linkedin_banner',
}) => {
  const [q, setQ] = useState(initialQuery);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setLoadError(null);
    try {
      const rows = await documentDesignService.getCompositionAssetCandidates({
        role,
        preset,
        q: q.trim() || undefined,
        limit: 24,
      });
      setItems(rows);
    } catch (err) {
      setItems([]);
      setLoadError(
        err.message
          || (role === 'logo' ? 'Could not load Brand Library logos' : 'Could not load Brand Library photos'),
      );
    } finally {
      setLoading(false);
    }
  }, [q, role, preset]);

  useEffect(() => {
    const t = setTimeout(load, q ? 350 : 0);
    return () => clearTimeout(t);
  }, [load, q]);

  return (
    <div className="dd-modal-overlay" onClick={onClose} role="presentation">
      <div className="dd-modal dd-picker mc-picker" onClick={(e) => e.stopPropagation()} role="dialog">
        <h3>{title}</h3>
        <input
          type="search"
          className="dd-search"
          placeholder={searchPlaceholder || 'Search Brand Library…'}
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
        {loadError && <p className="dd-error-inline">{loadError}</p>}
        {loading ? (
          <Spinner />
        ) : !items.length ? (
          <p className="dd-muted mc-picker-empty">
            {role === 'logo'
              ? 'No matches — try a shorter search term or browse logos in Brand Library.'
              : 'No matches — try a shorter search term or browse photos in Brand Library.'}
          </p>
        ) : (
          <div className="dd-picker-grid mc-picker-grid">
            {items.map((p) => (
              <button
                type="button"
                key={p.id}
                className="dd-media-card"
                onClick={() => onPick(p.media_asset_id || p.id, p)}
              >
                {mediaAssetPreviewUrl(p) ? (
                  <img
                    src={mediaAssetPreviewUrl(p)}
                    alt=""
                    loading="lazy"
                    className={isTransparentAsset(p) ? 'mc-checkerboard' : undefined}
                  />
                ) : (
                  <span>No preview</span>
                )}
                <span className="dd-media-name">
                  {p.file_name}
                  {p.is_vector && <span className="dd-badge cover"> SVG</span>}
                  {p.svg_background_removed && (
                    <span className="dd-badge muted" title="Full-artboard background removed from the source SVG">
                      Background removed
                    </span>
                  )}
                </span>
              </button>
            ))}
          </div>
        )}
        <div className="mc-modal-actions">
          <Button variant="ghost" onClick={onClose}>Cancel</Button>
        </div>
      </div>
    </div>
  );
};

export default MediaAssetPickModal;
